(() => {
  const pending = new Map();

  function initialize(root = document) {
    root.querySelectorAll('[data-mr-bestsellers]').forEach(async (carousel) => {
      if (pending.has(carousel)) return;
      const controller = new AbortController();
      pending.set(carousel, controller);
      try {
        const response = await fetch(carousel.dataset.sourceUrl, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Could not refresh bestsellers');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const products = page.querySelector('[data-mr-bestseller-products][data-sort="best-selling"]');
        if (!products?.children.length) throw new Error('No bestseller cards returned');
        const handles = (nodes) => Array.from(nodes, (node) => node.dataset.productHandle).join(',');
        // Keep the server-rendered cards when their ranking is already current.
        if (handles(carousel.children) !== handles(products.children)) {
          if (carousel.contains(document.activeElement) || carousel.scrollLeft !== 0) return;
          carousel.replaceChildren(...Array.from(products.children, (card) => document.importNode(card, true)));
        }
        carousel.dataset.bestsellersStatus = 'current';
      } catch (error) {
        if (error.name !== 'AbortError') carousel.dataset.bestsellersStatus = 'fallback';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    pending.forEach((controller, carousel) => {
      if (event.target.contains(carousel)) { controller.abort(); pending.delete(carousel); }
    });
  });
})();
